export function subdomainReducer(state: string = 'www') {
  return state;
}
